import React from 'react';
import { CtaButton } from './CtaButton';
import { Lock, Download, Smartphone } from 'lucide-react';
export function MidPageCTA() {
  return <section id="oferta" className="py-20 px-4 bg-brand-purple" data-id="element-120">
      <div className="max-w-3xl mx-auto" data-id="element-121">
        <div className="bg-brand-purpleDark rounded-3xl p-8 md:p-12 text-center border border-white/10 shadow-2xl" data-id="element-122">
          <p className="text-brand-yellow text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-123">
            Todo por solo
          </p>
          <div className="mb-2" data-id="element-124">
            <span className="text-gray-400 line-through text-2xl" data-id="element-125">$30.000</span>
          </div>
          <div className="text-7xl md:text-8xl font-serif font-bold text-brand-yellow mb-2" data-id="element-126">
            $6.999
          </div>
          <p className="text-white/80 text-lg mb-8" data-id="element-127">= menos que un delivery</p>

          <div className="bg-white/10 border border-white/20 rounded-xl p-4 mb-6 text-center" data-id="element-128">
            <p className="text-white font-semibold text-sm flex items-center justify-center gap-2 mb-2" data-id="element-129">
              🔒 Pago seguro mediante Mercado Pago
            </p>
            <p className="text-white/70 text-xs leading-relaxed" data-id="element-130">
              Te vamos a pedir email y dirección — es solo para tu comprobante
              legal. No se usa para envíos ni contacto. El ebook llega a tu mail
              en segundos.
            </p>
          </div>

          <CtaButton text="→ Quiero acceder ahora" size="xl" className="w-full mb-8" data-id="element-131" />

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-white/70 font-medium" data-id="element-132">
            <div className="flex items-center gap-1.5" data-id="element-133">
              <Lock className="w-4 h-4" data-id="element-134" /> Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-135">
              <Download className="w-4 h-4" data-id="element-136" /> Descarga instantánea
            </div>
            <div className="flex items-center gap-1.5" data-id="element-137">
              <Smartphone className="w-4 h-4" data-id="element-138" /> Funciona en cualquier
              dispositivo
            </div>
          </div>
        </div>
      </div>
    </section>;
}